/* offer-carousel.js — PDP dynamic coupon carousel (revised 3 Aug 2026).
   Nav: prev/next arrows + swipe + dots. NO auto-advance (removed per team feedback).
   Cart-aware ordering: on load and when the cart changes, cards re-sort so the best
   in-reach offer leads. Does NOT reset on tab-return (that caused the snap-to-first).
   Scoped to [data-offer-carousel]. */
(function () {
  if (window.__offerCarouselLoaded) return;
  window.__offerCarouselLoaded = true;

  // "within reach" window in rupees (GS-set, 2 Aug 2026): a coupon whose min-cart is at
  // most this far above the current cart subtotal is treated as usable-now for ranking.
  var REACH = 1500;

  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"></path></svg>';

  // ---- clipboard ----------------------------------------------------------
  function copyCode(btn, e) {
    if (e) e.stopPropagation();
    var code = btn.getAttribute('data-code');
    var ci = btn.querySelector('.oc-ci');
    if (!ci) return;
    var orig = ci.innerHTML;
    function done() {
      btn.classList.add('oc-copied');
      ci.innerHTML = TICK + '<span class="oc-ct">COPIED</span>';
      setTimeout(function () { btn.classList.remove('oc-copied'); ci.innerHTML = orig; }, 1500);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
    } else {
      fallbackCopy(code, done);
    }
  }
  function fallbackCopy(code, done) {
    var t = document.createElement('textarea');
    t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(t); done();
  }

  // ---- live cart subtotal (rupees) ---------------------------------------
  function getCartSubtotal() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var paise = (typeof c.items_subtotal_price === 'number') ? c.items_subtotal_price : c.total_price;
        return (paise || 0) / 100;
      })
      .catch(function () { return 0; });
  }

  // ---- ranking: usable-or-in-reach by saving desc, then rest nearest-first --
  function orderSlides(root, subtotal) {
    var track = root.querySelector('.oc-track');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('.oc-slide'));
    if (slides.length < 2) return;
    slides.forEach(function (s, i) { if (s.getAttribute('data-oi') === null) s.setAttribute('data-oi', i); });

    var ranked = slides.slice().sort(function (a, b) {
      var am = +a.getAttribute('data-min') || 0, bm = +b.getAttribute('data-min') || 0;
      var as = +a.getAttribute('data-saving') || 0, bs = +b.getAttribute('data-saving') || 0;
      var aIn = subtotal >= am || (am - subtotal) <= REACH;
      var bIn = subtotal >= bm || (bm - subtotal) <= REACH;
      if (aIn !== bIn) return aIn ? -1 : 1;
      if (aIn) {
        if (bs !== as) return bs - as;
      } else {
        var ga = am - subtotal, gb = bm - subtotal;
        if (ga !== gb) return ga - gb;
      }
      return (+a.getAttribute('data-oi')) - (+b.getAttribute('data-oi'));
    });

    var changed = ranked.some(function (s, i) { return slides[i] !== s; });
    if (changed) ranked.forEach(function (s) { track.appendChild(s); });
    return changed;
  }

  // ---- one carousel instance ----------------------------------------------
  function initRoot(root) {
    if (root.__ocInit) return;
    root.__ocInit = true;

    root.querySelectorAll('.oc-chip').forEach(function (b) {
      b.addEventListener('click', function (e) { copyCode(b, e); });
    });

    var track = root.querySelector('.oc-track');
    var slides = root.querySelectorAll('.oc-slide');
    var dots = [].slice.call(root.querySelectorAll('.oc-dots b'));
    var prev = root.querySelector('.oc-arrow.prev');
    var next = root.querySelector('.oc-arrow.next');
    var n = slides.length;
    if (!track || n === 0) return;

    var dotsRow = root.querySelector('.oc-dots');
    var single = n <= 1;
    if (single) {
      if (dotsRow) dotsRow.style.display = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
    }

    var idx = 0;
    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === n - 1;
    }
    function go(i) { idx = Math.max(0, Math.min(n - 1, i)); render(); }

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    // swipe
    var vp = root.querySelector('.oc-viewport'), x0 = null;
    if (vp) {
      vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      window.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      });
    }

    // Re-sort to the cart, then land on the (new) best offer.
    function applyCart(subtotal) {
      if (!single) orderSlides(root, subtotal);
      idx = 0; render();
    }

    render();                          // paint server order immediately
    getCartSubtotal().then(applyCart); // reorder to the live cart on load

    root.__ocApply = function () { getCartSubtotal().then(applyCart); };
  }

  function initAll() { document.querySelectorAll('[data-offer-carousel]').forEach(initRoot); }
  function refreshAll() {
    document.querySelectorAll('[data-offer-carousel]').forEach(function (r) { if (r.__ocApply) r.__ocApply(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);   // theme editor re-render
  setTimeout(initAll, 500);                                     // late-DOM safety net

  // Re-sort ONLY when the cart actually changes (not on tab-return/pageshow — that
  // reset-to-first was the behaviour the team flagged).
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, refreshAll);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') > -1) setTimeout(refreshAll, 900);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[name="add"], .add-to-cart, .product-form__submit');
    if (b) setTimeout(refreshAll, 900);
  }, true);
})();
